export default __webpack_public_path__ + "static/media/logo-example-08.438f015f.jpg";